import {Injectable} from '@angular/core';
import {ApiService} from '@common-lib';
import {map} from 'rxjs/operators';

@Injectable()
export class CategoriesService {

    constructor(private api: ApiService) {
    }

    getList(locale: string) {
        return this.api.get(`/admin/categories/${locale}`).pipe(map(({result}) => result));
    }
}



// WEBPACK FOOTER //
// ./src/app/pages-services/categories.service.ts